export namespace AppUtils {
  export const formatCompaniesToSelectOptions = (masters: Array<{ id: number; name: string }>) =>
    masters.map((item) => ({
      label: item.name,
      id: item.id,
      value: item.name,
    }));

  export const formatCupsToSelectOptions = (cups: Array<{ id: number; identifier: string; alias: string }>) =>
    cups.map((cup) => ({
      label: cup.alias,
      id: cup.id,
      value: cup.alias,
      identifier: cup.identifier,
    }));

  export const filterCupsByCompanies = (
    cups: Array<{ id: number; identifier: string; companyId: number; alias: string }>,
    company: { id: number; label: string; value: string } | null
  ) => {
    const filteredCups = cups.filter((cup) => company && company.id === cup.companyId);

    return filteredCups.map((cup) => ({
      label: cup.alias,
      id: cup.id,
      value: cup.alias,
      identifier: cup.identifier,
    }));
  };

  export const validateCupsStructure = (cups: string): { isValid: boolean; error?: string } => {
    if (!cups || cups.trim() === '') {
      return { isValid: false, error: 'CUPS is required' };
    }

    if (cups.length !== 20 && cups.length !== 22) {
      return { isValid: false, error: 'CUPS must have exactly 20 or 22 characters' };
    }

    if (!cups.startsWith('ES')) {
      return { isValid: false, error: 'CUPS must start with ES' };
    }

    const lastTwoChars = cups.slice(-2);
    if (!/^[A-Z]{2}$/.test(lastTwoChars)) {
      return { isValid: false, error: 'CUPS must end with 2 uppercase letters' };
    }

    return { isValid: true };
  };
}
